module.exports = __webpack_public_path__ + "img/文字版_00.4164f15e.png";